// extracted by mini-css-extract-plugin
module.exports =  {"container":"ServerError-module__container--V6Btw","img":"ServerError-module__img--eAb7n","title":"ServerError-module__title--e9h7g"};